import { render, staticRenderFns } from "./NewEditExpoCurrencies.vue?vue&type=template&id=e6283fd8&"
import script from "./NewEditExpoCurrencies.vue?vue&type=script&lang=js&"
export * from "./NewEditExpoCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports